import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccessManagementService } from '@libs/portal-common/services';
import { daysOfWeek, kendoMultiSelectTagMapper } from '@libs/portal-common/shared';
import { ContactsService } from '@libs/portal-common/services';
import { LocationsService } from '@libs/portal-common/services';
import { Problem, ProblemsService } from '@libs/portal-common/services';
import { ActivityFilter } from '../services/call-history.service';

@Component({
  selector: 'app-activity-filter',
  templateUrl: './activity-filter.component.html',
  styleUrls: ['./activity-filter.component.scss'],
})
export class ActivityFilterComponent implements OnInit {
  @Input() mode: string;

  @Input() filter: ActivityFilter;

  @Input() disabled = false;

  days = [];

  locations = [];
  filteredLocations = [];

  agents = [];
  filteredAgents = [];

  problems: string[] = [];
  filteredProblems: string[] = [];

  issues: string[] = [];
  filteredIssues: string[] = [];

  skypeAgentEmail = '';

  displayLocations = false;
  displayAgents = false;
  displayProblemsIssues = false;
  public tagMapper = kendoMultiSelectTagMapper;

  @Output() search = new EventEmitter<ActivityFilter>();

  constructor(
    private locationsService: LocationsService,
    private contactsService: ContactsService,
    private problemsService: ProblemsService,
    private accessManagementService: AccessManagementService,
  ) {
    this.days = daysOfWeek;
  }

  handleDaysFilter(value) {
    this.days = daysOfWeek.filter((s) => s.Name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  handleLocationsFilter(value: string): void {
    if (!value) {
      this.filteredLocations = [...this.locations];
      return;
    }

    const searchTerm = value.toLowerCase();

    this.filteredLocations = this.locations.filter((s) =>
      s.LotName.toLowerCase().includes(searchTerm)
    );
  }

  handleAgentsFilter(value) {
    this.filteredAgents = this.agents.filter((s) => s.Name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  handleProblemsFilter(value: string): void {
    if (!value) {
      this.filteredProblems = [...this.problems];
      return;
    }

    const searchTerm = value.toLowerCase();
    this.filteredProblems = this.problems.filter((p) => p.toLowerCase().includes(searchTerm));
  }

  handleIssuesFilter(value: string): void {
    if (!value) {
      this.filteredIssues = [...this.issues];
      return;
    }

    const searchTerm = value.toLowerCase();
    this.filteredIssues = this.issues.filter((i) => i.toLowerCase().includes(searchTerm));
  }

  ngOnInit() {
    if (this.accessManagementService.hasAccessPermissions({ entities: ['Locations'], access: 'CanRead' })) {
      this.displayLocations = true;
      this.locationsService.getAll().subscribe((response) => {
        this.locations = (response.Data || []).map(function (lot) {
          return {
            Id: lot.Id,
            LotName: `${lot.LotNumber} ${lot.LotName}`,
            Archived: lot.Archived,
            Disabled: !lot.Active,
          };
        });

        this.filteredLocations = this.locations;
      });
    }

    if (this.accessManagementService.hasAccessPermissions({ entities: ['Locations'], access: 'CanRead' })) {
      this.displayAgents = true;
      this.contactsService.getAgents().subscribe((response) => {
        this.agents = (response.Data || []).map(function (agent) {
          return {
            Id: agent.Id,
            SIP: agent.SipAddress,
            Name: agent.Name,
          };
        });

        this.filteredAgents = this.agents;
      });
    }

    if (this.accessManagementService.hasAccessPermissions({ entities: ['Rules'], access: 'CanRead' })) {
      this.displayProblemsIssues = true;
      this.problemsService.getAll().subscribe((response) => {
        const allProblems: Array<Problem> = response.Data || [];

        this.problems = Array.from(new Set(allProblems.map((p) => p.ProblemName))).sort((a, b) => a.localeCompare(b));
        this.filteredProblems = this.problems;

        const allIssueNames = allProblems.reduce(
          (names, problem) => names.concat((problem.Issues || []).map((issue) => issue.IssueName)),
          [] as string[],
        );
        this.issues = Array.from(new Set(allIssueNames)).sort((a, b) => a.localeCompare(b));
        this.filteredIssues = this.issues;
      });
    }
  }

  isProblemSelected(problemName: string): boolean {
    return this.filter.Problems && this.filter.Problems.includes(problemName);
  }

  isIssueSelected(issueName: string): boolean {
    return this.filter.Issues && this.filter.Issues.includes(issueName);
  }

  searchClick() {
    this.search.emit(this.filter);
  }

  toggleRandomSample(enabled: boolean) {
    this.filter.RandomSampleEnabled = enabled;
  }

  resetFilter() {
    this.filter = new ActivityFilter();
    this.search.emit(this.filter);
  }

  isLocationSelected(id: number): boolean {
    return this.filter.LotIds && this.filter.LotIds.includes(id);
  }

  isArray(val: any): boolean {
    return Array.isArray(val);
  }
}
